export default {
  items: [
    {
      name: 'Dashboard',
      url: '/super/visitorTag/dashboard',
      icon: 'icon-speedometer',
    },
    // {
    //   name: 'System Logs',
    //   url: '/super/log',
    //   icon: 'icon-puzzle',
    // },
    {
      name: 'Reports',
      url: '/super/report',
      icon: 'icon-note',
      children: [
        {
          name: 'View Meetings',
          url: '/super/report_meeting',
          icon: 'icon-chart',
        },
        {
          name: 'View Summary Report',
          icon: 'icon-people',
          url: '/super/summary-report',
        }, {
          name: 'Success/Failed Visitor Report',
          icon: 'icon-people',
          url: '/super/successfailedvisitor',
        }, {
          name: 'Widgets For Visitors Report',
          icon: 'icon-people',
          url: '/super/widgetsvisitors',
        }, {
          name: 'Summary report of receptionists',
          icon: 'icon-people',
          url: '/super/receptionistssummaryreport',
        }
      ],
    },
  ],
};
